/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'user': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: '<path pid="0" d="M11 14.378h-.127a6.976 6.976 0 01-3.842-1.206 6.664 6.664 0 00-4.987 6.488l.002.268h17.908v-.268a6.687 6.687 0 00-4.987-6.488A7.008 7.008 0 0111 14.378h0zm-3.923-2.312a.562.562 0 01.384.087A5.974 5.974 0 0011 13.279a6.168 6.168 0 003.54-1.127.546.546 0 01.119-.06.418.418 0 01.309-.02C18.534 12.904 21 16.013 21 19.66v.804a.539.539 0 01-.536.536h0H1.536A.537.537 0 011 20.464v-.804a7.751 7.751 0 016.032-7.588.767.767 0 01.045-.006zm3.923-.53c-2.896 0-5.281-2.36-5.281-5.28C5.719 3.331 8.105 1 11 1c2.896 0 5.281 2.36 5.281 5.281 0 2.923-2.385 5.255-5.28 5.255zm0-9.464a4.216 4.216 0 00-4.209 4.21c0 2.332 1.903 4.182 4.21 4.182a4.216 4.216 0 004.208-4.209c0-2.332-1.903-4.183-4.209-4.183z" _fill="#203F6A" _stroke="#203F6A" stroke-width=".5" fill-rule="evenodd"/>'
  }
})
